import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/services/store";
import { currentPersonSelector } from "../../slice";
import { NoContactsPage } from "../../Components/NoContactsPage";
import { ControlButtons } from "../../Components/ControlButtons";
import styles from "../styles.module.scss";
import { Layout } from "./Components/Layout";
import { ActivitiesTabForm } from "./Components/ActivitiesTabForm";

export const ActivitiesTab = () => {
  const { t } = useTranslation();

  const currentPerson = useAppSelector(currentPersonSelector);

  if (!currentPerson) return <NoContactsPage message={t("contactsPage.noSelected")} />;
  return (
    <ActivitiesTabForm defaultValuesPerson={currentPerson}>
      <div className={classNames(styles.root, styles["tab-container"])}>
        <Layout />
        <div className={styles["buttons-container"]}>
          <ControlButtons tabType="activities" />
        </div>
      </div>
    </ActivitiesTabForm>
  );
};
